var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player"},[_c('video',{attrs:{"width":"100%","poster":"/img/poster.gif","controls":""}},[_c('source',{attrs:{"src":_vm.itemView.urlPath,"type":_vm.itemView.type}})])])}
var staticRenderFns = []

export { render, staticRenderFns }